import { Component, OnInit, Input } from '@angular/core';
import { DataSharedService } from '../services/data-shared.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SuccessModal } from '../app.model';
import { SuccessModalComponent } from '../components/success-modal/success-modal.component';
import { InvoicesService } from '../services/invoices.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';



@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.css']
})
export class InvoiceDetailsComponent implements OnInit {

  @Input() public invoice: any;
  @Input() public invoiceType: string;
  invoiceDetails: FormGroup | any;
  candidateTrackingHrs: any = localStorage.getItem('candidateTrackingHrs') ? localStorage.getItem('candidateTrackingHrs') : 1;
  editClientInvoiceDate = false;
  editContractInvoiceDate = false;
  selectedInvoiceDate: Date;


  constructor(
    private activeModalService: NgbActiveModal,
    public dataSharedService: DataSharedService,
    private modalService: NgbModal,
    public invoiceService: InvoicesService,
    public router: Router,
    public datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    console.log(this.invoice);
    this.invoiceDetails = new FormGroup({
      client_invoice_date: new FormControl(this.invoice.client_invoice_date, Validators.required),
      invoice_date: new FormControl(this.invoice.invoice_date, Validators.required),
    });
  }

  onClose() {
    this.activeModalService.close();
  }

  onUpdate(invoiceType: any) {

    if (!this.invoiceDetails.valid) return;

    const formValue = this.invoiceDetails.value;
    const payload = invoiceType === "client"
      ? {
        client_invoice_date: this.formatDate(formValue.client_invoice_date),
      }
      : {
        invoice_date: this.formatDate(formValue.invoice_date),
      };
    console.log(payload, invoiceType);
    this.invoiceService.updateInvoice(this.invoice.uuid, payload).subscribe({
      next: () => {
        this.successModal('Invoice updated successfully.');
        this.activeModalService.close();
        this.reloadComponent(false, invoiceType === "client"
          ? 'invoices/bill-invoices'
          : 'invoices/pay-invoices');
      },
      error: (err) => {
        console.error(err);
      }
    });
  }
  onClientInvoiceDateChanged(event: any) {
    this.invoice.client_invoice_date = event.value;
    this.invoiceDetails.get('client_invoice_date')?.setValue(event.value);
    this.editClientInvoiceDate = false;
  }

  onContractorInvoiceDateChanged(event: any) {
    this.invoice.invoice_date = event.value;
    this.invoiceDetails.get('invoice_date')?.setValue(event.value);
    this.editContractInvoiceDate = false;
  }

  onSend(invoiceType: any, invoiceId: any) {

    const payload = {
      'invoice_type': invoiceType,
    }
    this.invoiceService.sendInvoices([invoiceId], payload).subscribe({
      next: (response) => {
        this.successModal('Invoice Sent Successfully.');
        this.activeModalService.close();
        this.reloadComponent(false, invoiceType == "client"
          ? 'invoices/bill-invoices'
          : 'invoices/pay-invoices');
      },
      error: (err) => {
      }
    });
  }

  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    //skipLocationChange:true means dont update the url to / when navigating
    console.log("Current route I am on:", this.router.url);
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        console.log(`After navigation I am on:${this.router.url}`)
      })
    })
  }

  successModal(message: string) {
    const modalRef = this.modalService.open(SuccessModalComponent, {
      size: 'sm',
      modalDialogClass: 'success-modal',
      backdrop: false,
    });
    let data: SuccessModal = {
      message: message,
      image: 'assets/img/checkmark.png',
      duration: 2000,
    }
    modalRef.componentInstance.data = data;
    modalRef.result.then((data) => {
      if (data?.action === 'yes') {
        this.activeModalService.close();
      }
    });
  }

  formatDate = (date: Date): any => {
    return this.datePipe.transform(date, 'yyyy-MM-dd')!;

  };

}
